<template>
	<Tooltip :text="text">
		<FontAwesomeIcon
			class="cursor-pointer"
			icon="circle-info" />
		<template #tooltip>
			<slot name="tooltip"></slot>
		</template>
	</Tooltip>
</template>

<script setup lang="ts">
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import Tooltip from "@/components/library/Tooltip/Tooltip.vue";
defineProps({
	text: {
		type: String,
		default: "",
	},
});
</script>